class WhitelistEmail {
	constructor({
		email,
		verification_status: verificationStatus
	} = {}) {
		this._email = email;
		this._status = verificationStatus;
	}

	getKey = () => this._email;

	getEmail = () => this._email;

	getStatus = () => this._status;

}

export default WhitelistEmail;
